var React = require('react');

function Rectangles (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M61 30.5L30.5 0L0 30.5L30.5 61L61 30.5ZM10.5792 30.5L30.5 10.5792L50.4208 30.5L30.5 50.4208L10.5792 30.5Z","fill":"url(#paint0_linear)","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"paint0_linear","x1":"61","y1":"5.08497e-06","x2":"-10.791","y2":"24.6131","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"stopColor":"#1D38F1","key":0}),React.createElement("stop",{"offset":"0.467181","stopColor":"#414EE1","key":1}),React.createElement("stop",{"offset":"1","stopColor":"#FCA18D","key":2})]))]);
}

Rectangles.defaultProps = {"width":"61","height":"61","viewBox":"0 0 61 61","fill":"none"};

module.exports = Rectangles;

Rectangles.default = Rectangles;
